import {
  Button,
  Drawer,
  Popconfirm,
  Skeleton,
  Space,
  Table,
  Tooltip,
} from "antd";
import React, { useState } from "react";
import { WarningOutlined } from "@ant-design/icons";
import useSWR from "swr";
import dayjs from "dayjs";
import { AddTherapyUtilizationReview } from "./AddTherapyUtilizationReview";
import { fetcherhn } from "../../services/fectcher";
import Search from "antd/es/input/Search";
import { deleteTurf } from "../../api/CareEventsApi";
import { openNotification } from "../../common/elements/myNotification";
import { handleToggle } from "../../common/elements/toggleSeeMore";
import { FaEdit, FaRegTrashAlt } from "react-icons/fa";
import { FiSend } from "react-icons/fi";
import SendEmail from "../../common/elements/SendEmail";

export const TherapyUtilizationReview = (props) => {
  const initialReqState = {
    key: "",
    guid: "",
    mbi: props?.mbiid,
    reviewDate: dayjs().format("YYYY-MM-DD"), // default to today
    medicareA: "No",
    medicareB: "No",
    therapyGoals: "",
    plfBaseLine: "",
    therapyDetails: "",
    hasPatientMetMaximumPotential: "",
    caseManagerRecommendations: "",
    createdBy: sessionStorage.getItem("userName") || "",
    modifiedBy: "",
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [query, setQuery] = useState();
  const [editRecord, setEditRecord] = useState(initialReqState);

  const { data, mutate, isLoading } = useSWR(
    `GetTherapyUtilizationReview?id=${props?.mbiid}`,
    fetcherhn
  );

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = async (e) => {
    if (e) {
      mutate();
    }
    setIsModalOpen(false);
    setEditRecord(initialReqState);
  };

  const handleCancel = (e) => {
    setIsModalOpen(false);
    setEditRecord(initialReqState);
  };

  const [mail, setMail] = useState(false);

  const sendDatatoEmail = (record) => {
    setMail(true);
    setEditRecord(record);
  };

  const handleModalClose = (e) => {
    setEditRecord(initialReqState);
    setMail(false);
  };

  const edit = (record) => {
    setIsModalOpen(true);
    setEditRecord(record);
  };

  const handleDelete = async (record) => {
    const body = { ...record, modifiedBy: sessionStorage.getItem("userName") };
    const deleteResult = await deleteTurf(body);
    if (deleteResult.status) {
      mutate();
      openNotification(
        "success",
        "Deleted",
        "Therapy Utilization Review Deleted Successfully!"
      );
    }
  };

  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedRows2, setExpandedRows2] = useState([]);
  const [expandedRows3, setExpandedRows3] = useState([]);

  const columns = [
    {
      key: 6,
      title: "Medicare A/B",
      dataIndex: "medicareA",
      render: (_, { medicareA, medicareB }) => (
        <>
          {medicareA === "Yes" && <div>{"Medicare A"}</div>}
          {medicareB === "Yes" && <div>{"Medicare B"}</div>}
        </>
      ),
    },
    {
      key: 4,
      title: "Has patient met maximum potential?",
      dataIndex: "hasPatientMetMaximumPotential",
      editable: true,
      width: "15%",
    },
    {
      key: 2,
      title: "Goals of Therapy",
      dataIndex: "therapyGoals",
      render: (text, record) => {
        const isExpanded = expandedRows3.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows3)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );

        return <div>{content}</div>;
      },
    },
    {
      key: 7,
      title: "Therapy Services and frequency",
      dataIndex: "therapyDetails",
      render: (text, record) => {
        const isExpanded = expandedRows.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );
        return <div>{content}</div>;
      },
    },

    {
      key: 5,
      width: 300,
      title: "Case Manager Recommendations",
      dataIndex: "caseManagerRecommendations",
      render: (text, record) => {
        const isExpanded = expandedRows2.includes(record.key);
        const content =
          text.length > 100 ? (
            <span>
              {isExpanded ? text : `${text.substring(0, 100)}...`}
              <Button
                type="link"
                onClick={() => handleToggle(record.key, setExpandedRows2)}
              >
                {isExpanded ? "See less" : "See more"}
              </Button>
            </span>
          ) : (
            text
          );

        return <div>{content}</div>;
      },
    },
    {
      key: 3,
      title: "Review Date ",
      dataIndex: "reviewDate",
      render: (_, { reviewDate, createdBy }) => {
        const [name] = createdBy.split("@");
        return (
          <>
            <div>{dayjs(reviewDate).format("YYYY-MM-DD")}</div>
            <div>{name}</div>
          </>
        );
      },
    },
    {
      key: "key",
      title: "Operation",
      dataIndex: "guid",
      fixed: "right",
      width: 110,
      render: (_, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <FaEdit
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => edit(record)}
                color="blue"
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Ok to Delete?"
                onConfirm={() => handleDelete(record)}
                icon={
                  <WarningOutlined
                    style={{
                      color: "red",
                    }}
                  />
                }
              >
                <FaRegTrashAlt
                  size={20}
                  className=" tw-cursor-pointer"
                  color="red"
                />
              </Popconfirm>
            </Tooltip>
            <Tooltip title="Send Email">
              <FiSend
                size={20}
                className=" tw-cursor-pointer"
                onClick={() => sendDatatoEmail(record)}
                color="green"
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  const finalResult = data
    ? data.filter((item) => {
        return [
          "reviewDate",
          "therapyGoals",
          "therapyDetails",
          "hasPatientMetMaximumPotential",
          "caseManagerRecommendations",
          "createdBy",
        ].some((key) =>
          (item[key]?.toString()?.toLowerCase() ?? "").includes(
            query?.toLowerCase() ?? ""
          )
        );
      })
    : data;

  if (isLoading) {
    return <Skeleton active={isLoading} />;
  }

  return (
    <>
      <div className="tw-flex tw-justify-between tw-mt-3 ">
        <p
          className="pt-1"
          style={{
            color: "#D2691E",
            fontWeight: "600",
          }}
        >
          Therapy Utilization Review
        </p>

        <Space>
          <Search
            className=" tw-mb-4"
            size="middle"
            placeholder="Search"
            onChange={(e) => setQuery(e.target.value)}
            allowClear
          />
          <Button type="primary" onClick={showModal} className="tw-mb-4 ">
            Add
          </Button>
        </Space>
      </div>

      {isModalOpen && (
        <Drawer
          open={isModalOpen}
          title={"Add/Update Therapy Utilization Review"}
          onClose={handleCancel}
          width={600}
          footer={null}
        >
          <AddTherapyUtilizationReview
            callback={handleOk}
            editRecord={editRecord}
            key={editRecord?.key}
          />
        </Drawer>
      )}
      <Table
        bordered
        size="middle"
        dataSource={finalResult}
        columns={columns}
      />

      {mail && (
        <SendEmail
          open={mail}
          close={handleModalClose}
          editRecord={editRecord}
          modalTitle={"Therapy Utilization Review"}
          patientName={props?.patient?.label || ""}
        />
      )}
    </>
  );
};
